import type { Permission, StackConRiepilogo } from "./types.ts";

export type StatoStack = "non-avviato" | "fermo" | "attivo" | "da-applicare" | "errore";

export type AzionePrincipale = { tipo: "avvia" } | { tipo: "rilascia" | "riprova"; revisione: number } | null;

const fallito = (s: StackConRiepilogo) => s.riepilogo.ultimoRilascio?.esito === "failed";

export function statoStack(s: StackConRiepilogo): StatoStack {
  if (fallito(s)) return "errore";
  // Fermato dopo almeno un rilascio non è «mai avviato».
  if (s.deployedRevisionId === null) return s.riepilogo.ultimoRilascio === null ? "non-avviato" : "fermo";
  if (s.riepilogo.daApplicare) return "da-applicare";
  return "attivo";
}

export function azionePrincipale(s: StackConRiepilogo, permessi: readonly Permission[]): AzionePrincipale {
  if (!permessi.includes("stack:deploy")) return null;
  const { revisioneSalvata, daApplicare } = s.riepilogo;
  if (s.deployedRevisionId === null) return { tipo: "avvia" };
  if (revisioneSalvata === null) return null;
  if (fallito(s)) return { tipo: "riprova", revisione: revisioneSalvata };
  if (daApplicare) return { tipo: "rilascia", revisione: revisioneSalvata };
  return null;
}

/**
 * C'è qualcosa da guardare nella panoramica: un rilascio passato, anche se ora
 * è fermo, o container già presenti, come quelli di uno stack importato.
 */
export function haPanoramica(s: StackConRiepilogo): boolean {
  return s.riepilogo.ultimoRilascio !== null || (s.riepilogo.container?.totali ?? 0) > 0;
}

export function schedaPredefinita(s: StackConRiepilogo): "panoramica" | "configurazione" {
  return haPanoramica(s) ? "panoramica" : "configurazione";
}

export function filtraStack(
  elenco: readonly StackConRiepilogo[],
  testo: string,
  stato: StatoStack | "tutti",
): StackConRiepilogo[] {
  const ago = testo.trim().toLowerCase();
  return elenco.filter(
    (s) =>
      (stato === "tutti" || statoStack(s) === stato) &&
      (ago === "" || `${s.name} ${s.description ?? ""}`.toLowerCase().includes(ago)),
  );
}

/** Le date di SQLite arrivano senza fuso («2026-10-21 15:41:00») e sono UTC. */
export function dataSqlite(iso: string): Date {
  return new Date(iso.includes("T") ? iso : `${iso.replace(" ", "T")}Z`);
}
